import { render } from "./DeviationVehicleChangeInput.vue?vue&type=template&id=83178d42"
import script from "./DeviationVehicleChangeInput.vue?vue&type=script&lang=ts"
export * from "./DeviationVehicleChangeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script